import { useEffect, useRef, useState } from "react";

interface UseIdleOptions {
  initialState?: boolean;
  events?: string[];
  idleTime?: number;
}

const defaultOptions: Required<UseIdleOptions> = {
  initialState: false,
  events: ["mousemove", "keydown", "scroll", "click", "mousedown", "resize", "touchstart", "wheel"],
  idleTime: 30000,
};

const useIdle = (customOptions: UseIdleOptions = {}) => {
  const { events, idleTime, initialState } = { ...defaultOptions, ...customOptions };
  const [isIdle, setIsIdle] = useState(initialState);
  const timerRef = useRef<ReturnType<typeof setTimeout>>(null);

  useEffect(() => {
    const handleTimeout = () => {
      setIsIdle(true);
    };

    const handleEvent = () => {
      setIsIdle(false);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(handleTimeout, idleTime);
    };

    const handleVisibilityChange = () => {
      if (!document.hidden) handleEvent();
    };

    timerRef.current = setTimeout(handleTimeout, idleTime);

    events.forEach(event => window.addEventListener(event, handleEvent));
    if (events.includes("visibilitychange")) document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      events.forEach(event => window.removeEventListener(event, handleEvent));
      if (events.includes("visibilitychange")) document.removeEventListener("visibilitychange", handleVisibilityChange);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [events, idleTime]);

  return isIdle;
};

export { useIdle };
